import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Menu } from 'components/Header/types'
import { Plataforma, PlataformaState } from './types'
import { RootState } from '..'

const initialState: PlataformaState = {
  plataformaSelecionada: {
    id: 0,
    codigo: '',
    nome: '',
    codigoIconeLight: '',
    codigoIconeDark: '',
    codigoTipo: '',
    indicadorAtivo: false,
    codigoSuperior: '',
    nomeHost: ''
  },
  menusPersonalizados: [],
  menuPlataformas: [],
  carregandoPlataformas: false
}

export const plataformaSlice = createSlice({
  name: 'plataforma',
  initialState,
  reducers: {
    setPlataformaSelecionada: (state, action: PayloadAction<Plataforma>) => {
      state.plataformaSelecionada = action.payload
    },
    unsetPlataformaSelecionada: state => {
      state.plataformaSelecionada = initialState.plataformaSelecionada
    },
    setMenusPersonalizados: (state, action: PayloadAction<Menu[]>) => {
      state.menusPersonalizados = action.payload
    },
    unsetMenusPersonalizados: state => {
      state.menusPersonalizados = initialState.menusPersonalizados
    },
    setMenuPlataformas: (state, action: PayloadAction<Menu[]>) => {
      state.menuPlataformas = action.payload
    },
    unsetMenuPlataformas: state => {
      state.menuPlataformas = initialState.menuPlataformas
    },
    setCarregandoPlataformas: (state, action: PayloadAction<boolean>) => {
      state.carregandoPlataformas = action.payload
    },
    unsetCarregandoPlataformas: state => {
      state.carregandoPlataformas = initialState.carregandoPlataformas
    }
  }
})

export const {
  setPlataformaSelecionada,
  unsetPlataformaSelecionada,
  setMenusPersonalizados,
  unsetMenusPersonalizados,
  setMenuPlataformas,
  unsetMenuPlataformas,
  setCarregandoPlataformas,
  unsetCarregandoPlataformas
} = plataformaSlice.actions

export const plataformaReducer = plataformaSlice.reducer
export const selectPlataformaSelecionada = (state: RootState) =>
  state.plataforma.plataformaSelecionada
export const selectMenusPersonalizados = (state: RootState) =>
  state.plataforma.menusPersonalizados
export const selectMenuPlataformas = (state: RootState) =>
  state.plataforma.menuPlataformas
export const selectCarregandoPlataformas = (state: RootState) =>
  state.plataforma.carregandoPlataformas
